import axios, { AxiosInstance } from 'axios';

export const fetcher = axios.create();

export interface TFetcher extends AxiosInstance {}
